import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-reverify-forgot-password',
  templateUrl: './reverify-forgot-password.component.html',
  styleUrls: ['../../app.component.scss', './reverify-forgot-password.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ForgotPasswordComponent implements OnInit {

  resendMailData = <any>{};

  constructor(private _auth: AuthService, private _router: Router) {
  }

  ngOnInit() {
  }

  resetForgotPassEmail() {
    this.resendMailData.email = "";
  }

  reverifyEmailPassword() {
    this._auth.resendEmailPasswordChange(this.resendMailData)
      .subscribe(
        res => {
        },
        error => {
          if (error.status == 0) {
          } else {
          }
        }
      )
  }

}
